import { useCallback } from 'react'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import styled from 'styled-components'
import DefaultPageLayout from '~/components/templates/DefaultPageLayout'
import Header from '~/components/molecules/Modal/Header'

export default function TokushohoPage() {
  const router = useRouter()

  const handleClose = useCallback(() => {
    router.push('/')
  }, [router])

  return (
    <DefaultPageLayout>
      <NextSeo
        title='特定商取引法に基づく表記'
        openGraph={{
          url: `${process.env.origin}/terms/tokushoho`,
          title: '特定商取引法に基づく表記 - Ambass'
        }}
      />
      <StyledHeader title='特定商取引法に基づく表記' onClose={handleClose} />
      <Container>
        <Row>
          <Head>事業者名</Head>
          <Detail>September6合同会社</Detail>
        </Row>
        <Row>
          <Head>代表者名</Head>
          <Detail>省略した記載については、電子メール等の請求により遅滞なく開示いたします。</Detail>
        </Row>
        <Row>
          <Head>所在地</Head>
          <Detail>省略した記載については、電子メール等の請求により遅滞なく開示いたします。</Detail>
        </Row>
        <Row>
          <Head>電話番号</Head>
          <Detail>省略した記載については、電子メール等の請求により遅滞なく開示いたします。</Detail>
        </Row>
        <Row>
          <Head>メールアドレス</Head>
          <Detail>省略した記載については、電子メール等の請求により遅滞なく開示いたします。</Detail>
        </Row>
        <Row>
          <Head>販売価格</Head>
          <Detail>販売価格は消費税を含む価格で表示されています。</Detail>
        </Row>
        <Row>
          <Head>代金の支払方法</Head>
          <Detail>クレジットカード</Detail>
        </Row>
        <Row>
          <Head>代金の支払時期</Head>
          <Detail>クレジットカード: 商品注文時点でお支払いが確定します。</Detail>
        </Row>
        <Row>
          <Head>商品の引渡時期</Head>
          <Detail>決済完了後、即時ダウンロード可能となります。</Detail>
        </Row>
        <Row>
          <Head>返品等についての特約に関する事項</Head>
          <Detail>商品に欠陥があり、当社が認める場合を除き、返品には応じません。</Detail>
        </Row>
      </Container>
    </DefaultPageLayout>
  )
}

const StyledHeader = styled(Header)`
  margin: 24px -8px 48px;
`
const Container = styled.div`
  display: grid;
  grid-gap: 24px;
`
const Row = styled.div``
const Head = styled.div`
  ${({ theme }) => theme.fonts.Bold14};
  color: ${({ theme }) => theme.colors.OnSurface5};
`
const Detail = styled.div`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
